import { motion } from "framer-motion";
import { MessageCircle, Car, CalendarHeart } from "lucide-react";
import { waLink } from "./data";
import { Reveal, Overline } from "./Reveal";

const FECHAS = [
  { id: "carnaval", title: "Carnaval", when: "Febrero / marzo", img: "/img/carnaval.jpg", text: "Samba, blocos y desfiles. Te recomendamos reservar con anticipación." },
  { id: "ano-nuevo", title: "Año Nuevo", when: "Diciembre", img: "/img/reveillon.jpg", text: "Recibí el año vestido de blanco frente al mar, con fuegos artificiales en la playa." },
  { id: "julio", title: "Vacaciones de julio", when: "Julio", img: "/img/gramado.jpg", alt: "Gramado, Rio Grande do Sul", text: "Aprovechá las vacaciones de invierno para escaparte en familia a Brasil." },
];

const FechaCard = ({ f, i }) => (
  <motion.a data-testid={`special-date-${f.id}`} href={waLink(`¡Hola Jaha Brasilpe! Quiero planificar un viaje para ${f.title}.`)} target="_blank" rel="noopener noreferrer"
    initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay: 0.1 * i, ease: [0.16, 1, 0.3, 1] }}
    className="group relative block h-[420px] overflow-hidden rounded-[2rem]">
    <img src={f.img} alt={f.alt || f.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-mar via-mar/40 to-transparent" />
    <span className="absolute left-6 top-6 flex items-center gap-1.5 rounded-full bg-sol px-3 py-1 text-xs font-bold text-mar"><CalendarHeart className="h-3.5 w-3.5" />{f.when}</span>
    <div className="absolute inset-x-0 bottom-0 p-7 text-white">
      <h3 className="font-display text-3xl font-extrabold">{f.title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-white/90">{f.text}</p>
      <span className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-sol"><MessageCircle className="h-4 w-4" /> Consultar fechas</span>
    </div>
  </motion.a>
);

const LongTrip = () => (
  <Reveal>
    <div data-testid="long-trip-card" className="relative mt-6 overflow-hidden rounded-[2rem] bg-selva text-arena lg:grid lg:grid-cols-12">
      <div className="relative h-72 sm:h-96 lg:col-span-7 lg:h-[460px]">
        <img src="/img/fortaleza.jpg" alt="Costa de Fortaleza" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-selva/70 to-transparent lg:bg-gradient-to-l lg:from-selva/60" />
      </div>
      <div className="relative flex flex-col justify-center p-8 sm:p-12 lg:col-span-5">
        <span className="flex w-fit items-center gap-1.5 rounded-full bg-sol px-3 py-1 text-xs font-bold text-selva"><Car className="h-3.5 w-3.5" /> Viaje de larga duración</span>
        <h3 className="mt-5 font-display text-4xl font-extrabold leading-tight">En auto hasta <span className="font-serif-i font-normal text-sol">Fortaleza</span></h3>
        <p className="mt-4 text-base leading-relaxed text-arena/90">
          Subís en auto hasta Fortaleza y volvés bajando por la costa, parando en las playas y ciudades que elijas. Te planificamos cada tramo, las paradas, el hospedaje y los costos.
        </p>
        <a data-testid="long-trip-whatsapp" href={waLink("¡Hola Jaha Brasilpe! Quiero planificar un viaje largo en auto hasta Fortaleza, bajando por la costa.")} target="_blank" rel="noopener noreferrer"
          className="mt-7 inline-flex w-fit items-center gap-2 rounded-full bg-barro px-7 py-4 font-bold text-white transition-transform duration-300 hover:-translate-y-1">
          <MessageCircle className="h-5 w-5" /> Planificar mi ruta larga
        </a>
      </div>
    </div>
  </Reveal>
);

export const SpecialTrips = () => (
  <section id="viajes-especiales" data-testid="special-trips-section" className="bg-arena pb-24 lg:pb-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
      <Reveal>
        <Overline>Fechas especiales y viajes largos</Overline>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-mar sm:text-6xl">
          Hay fechas que <span className="font-serif-i font-normal text-barro">se viven en Brasil.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {FECHAS.map((f, i) => <FechaCard key={f.id} f={f} i={i} />)}
      </div>
      <LongTrip />
    </div>
  </section>
);
